import { render, staticRenderFns } from "./ModalSubMenuBetToolMenu.vue?vue&type=template&id=4f5aab66&scoped=true&"
import script from "./ModalSubMenuBetToolMenu.vue?vue&type=script&lang=js&"
export * from "./ModalSubMenuBetToolMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubMenuBetToolMenu.vue?vue&type=style&index=0&id=4f5aab66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5aab66",
  null
  
)

export default component.exports